<app-fullscreen-modal-card>
	<div class="flex flex-col items-center max-w-sm gap-common p-common xs:p-0">
		<div class="flex flex-col items-center ">
			<p translate="enable-banking.modals.success.header"></p>
			<h3 translate="enable-banking.modals.success.body"></h3>
		</div>
		<app-loader></app-loader>
	</div>
</app-fullscreen-modal-card>
